import React from 'react';
import PropTypes from 'prop-types';
import { MessageSubtypes } from '../constants';

export const SystemMessageIcon = ({ subtype }) => {
  switch (subtype) {
    case MessageSubtypes.FILE:
      return (
        <svg viewBox="0 0 17 17" className="type-icon" focusable="false">
          <circle cx="8.5" cy="8.5" r="8.5" />
          <polygon points="2.67 8.47 6.48 10.21 12.77 4.3 2.67 8.47" />
          <polygon points="6.93 10.66 8.73 14.41 12.77 4.34 6.93 10.66" />
        </svg>
      );
    case MessageSubtypes.ONLINE:
      return (
        <svg viewBox="0 0 17 17" className="type-icon" focusable="false">
          <circle cx="8.5" cy="8.5" r="8.5" />
          <path d="M12.62 5.24a.8.8 0 0 0-1.12.14L8 9.92 5.45 7.23a.8.8 0 0 0-1.16 1.09l3.12 3.32a.89.89 0 0 0 1.29 0l4.07-5.26a.8.8 0 0 0-.15-1.14z" />
        </svg>
      );
    case MessageSubtypes.OFFLINE:
      return (
        <svg viewBox="0 0 17 17" className="type-icon" focusable="false">
          <circle cx="8.5" cy="8.5" r="8.5" />
          <path d="M9.78 8.5l2.29-2.29a.9.9 0 1 0-1.28-1.28L8.5 7.22 6.21 4.93a.9.9 0 0 0-1.28 1.28L7.22 8.5l-2.29 2.29a.9.9 0 0 0 1.28 1.28L8.5 9.78l2.29 2.29a.9.9 0 0 0 1.28-1.28z" />
        </svg>
      );
    default:
      return (
        <svg viewBox="0 0 17 17" className="type-icon" focusable="false">
          <circle cx="8.5" cy="8.5" r="8.5" />
          <path d="M5.76 8.07c0-.14.09-.27.12-.4s.09-.17.23-.21a13.2 13.2 0 0 1 1.36-.36 3.39 3.39 0 0 1 1.62.07 1.2 1.2 0 0 1 .91 1.1 3.54 3.54 0 0 1-.23 1.23c-.2.55-.4 1.11-.58 1.67a2.31 2.31 0 0 0-.14.78.87.87 0 0 0 0 .19c0 .2.22.3.45.33a2.57 2.57 0 0 0 1.09-.08l.22-.06-.16.52c-.46.13-.91.29-1.37.39a3.49 3.49 0 0 1-1.65 0 1.41 1.41 0 0 1-1-.71 1.11 1.11 0 0 1-.1-.59 4.63 4.63 0 0 1 .31-1.24c.2-.57.39-1.14.58-1.71a1.5 1.5 0 0 0 .07-.6.81.81 0 0 0 0-.18c-.06-.2-.22-.29-.5-.32A2.79 2.79 0 0 0 5.85 8zM7.88 4.82A1.4 1.4 0 0 1 9 3.47a1.51 1.51 0 0 1 1.38.36 1.31 1.31 0 0 1 .07 1.9 1.54 1.54 0 0 1-2.38-.2 1.22 1.22 0 0 1-.19-.71z" />
        </svg>
      );
  }
};

SystemMessageIcon.propTypes = {
  subtype: PropTypes.string.isRequired,
};

export const composeType = subtype => {
  let type = 'chat-message system-message ';
  const {
    FILE, ONLINE, OFFLINE,
  } = MessageSubtypes;

  if (subtype === FILE) {
    type += 'send-file';
  } else if (subtype === ONLINE) {
    type += 'online';
  } else if (subtype === OFFLINE) {
    type += 'offline';
  } else {
    type += 'information';
  }

  return type;
};
